// import { Text } from '@chakra-ui/react';
import { Center, Span } from '@chakra-ui/react';
import { GenderEnum } from '@halo/chat-sdk-react';
import { ManIcon, WomanIcon, OtherGenderIcon } from '@halo/ui-chat-react';

interface GenderProps {
  gender?: GenderEnum;
}

const Gender = ({ gender }: GenderProps) => {
  const { t } = useTranslation();
  return (
    <Span color="fg.muted">
      {gender == GenderEnum.MALE ? (
        <ManIcon />
      ) : gender == GenderEnum.FEMALE ? (
        <WomanIcon />
      ) : // <Text color="fg.muted">Unknown</Text>
      gender == GenderEnum.OTHER || gender === '' ? (
        <Center gap="1">
          <OtherGenderIcon />
          {t('profile.other')}
        </Center>
      ) : (
        <Center gap="1">
          {gender && <OtherGenderIcon />} {gender}
        </Center>
      )}
    </Span>
  );
};

const MemoizedGender = memo(Gender);
export { MemoizedGender as Gender };
